enum QuoteStatus {
	STARTED = 'Started',
	COMPLETED = 'Completed',
	PROPOSALS_SENT = 'Proposal Sent',
	PROPOSALS_SIGNED = 'Proposal Signed',
}

export default QuoteStatus;
